import {
  Box,
  Typography,
  Button,
  Snackbar,
  TextField,
  InputAdornment,
  IconButton,
  LinearProgress,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import StoreIcon from "@mui/icons-material/Store";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { UserInfoStyle as styles } from "./UserInfoStyle";
import { useUserInfo } from "../hooks/logic/useUserInfo";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ConfirmDialog from "../components/ConfirmDialog";
import AmazonSettingDialog from "../components/AmazonSettingDialog";

const UserInfo = () => {
  const {
    inputRef,
    handleUpdateCheck,
    handleUpdate,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    lastName,
    setLastName,
    firstName,
    setFirstName,
    mailAddress,
    driverName,
    setDriverName,
    shopName,
    setShopName,
    isResetPassword,
    setIsResetPassword,
    oldPassword,
    setOldPassword,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    showOldPassword,
    setShowOldPassword,
    showNewPassword,
    setShowNewPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    isPasswordValid,
    isValidLength,
    isPasswordMatch,
    validationCheck,
    showSellerId,
    setShowSellerId,
    sellerId,
    setSellerId,
    changeSellerIdDialogOpen,
    setChangeSellerIdDialogOpen,
    amazonSettingDialogOpen,
    setAmazonSettingDialogOpen,
    handleUpdateAmazonInfo,
    ImageButton,
    handleConnectAmazon,
  } = useUserInfo();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ConfirmDialog
        open={changeSellerIdDialogOpen}
        title="確認"
        message="セラーIDを更新します。よろしいですか？"
        buttons={[
          {
            label: "戻る",
            variant: "outlined",
            onClick: () => setChangeSellerIdDialogOpen(false),
          },
          {
            label: "OK",
            variant: "contained",
            onClick: () => {
              setChangeSellerIdDialogOpen(false);
              handleUpdate();
            },
          },
        ]}
      />
      <AmazonSettingDialog
        open={amazonSettingDialogOpen}
        onClose={() => {
          // setSelectedParent(null);
          setAmazonSettingDialogOpen(false);
        }}
        statusId={4}
        onUpdate={handleUpdateAmazonInfo}
      />

      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          ユーザー情報
        </Typography>
      </Box>
      <Box
        mt={2}
        p={2}
        bgcolor="#fff"
        borderRadius={2}
        boxShadow={2}
        mx="auto"
        width="80%" // 全体の幅を拡張
      >
        <Box display="flex" justifyContent="center" gap={4}>
          <TextField
            label="性"
            sx={{ width: "40%" }}
            margin="normal"
            size="small"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="名"
            sx={{ width: "40%" }}
            margin="normal"
            size="small"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box display="flex" justifyContent="center" gap={4}>
          <TextField
            label="配送名"
            sx={{ width: "40%" }}
            margin="normal"
            size="small"
            value={driverName}
            onChange={(e) => setDriverName(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocalShippingIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="ショップ名"
            sx={{ width: "40%" }}
            margin="normal"
            size="small"
            value={shopName}
            onChange={(e) => setShopName(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <StoreIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box display="flex" justifyContent="center" gap={4}>
          <Box sx={{ width: "40%" }}>
            <TextField
              label="メールアドレス"
              margin="normal"
              size="small"
              value={mailAddress}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
              }}
              disabled
              fullWidth
            />
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              ※メールアドレスを変更したい場合は管理者へご連絡ください
            </Typography>
          </Box>

          <Box sx={{ width: "40%" }}>
            {/* <Box mt={2} sx={{ width: "30%" }}>
              <Button variant="contained" color="primary" fullWidth>
                Amazon設定
              </Button>
            </Box> */}
            {/* <TextField
              label="セラーID"
              type={showSellerId ? "text" : "password"}
              margin="normal"
              size="small"
              fullWidth
              value={sellerId}
              onChange={(e) => setSellerId(e.target.value)}
              // sx={{ width: "40%" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LineStyleIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowSellerId((prev) => !prev)}
                    >
                      {showOldPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {getSellerId === undefined
                ? "セラーIDが設定されていません"
                : `右記のセラーIDが設定されています${getSellerId}`}
            </Typography> */}
          </Box>
        </Box>
      </Box>

      <Box
        mt={2}
        p={2}
        bgcolor="#fff"
        borderRadius={2}
        boxShadow={2}
        mx="auto"
        width="80%"
      >
        <Box display="flex" justifyContent="center" alignItems="center" mb={0}>
          <input
            type="checkbox"
            id="reset-password"
            checked={isResetPassword}
            onChange={(e) => setIsResetPassword(e.target.checked)}
            style={{ marginRight: "8px" }}
          />
          <label htmlFor="reset-password">パスワード再設定</label>
        </Box>

        <Box display="flex" justifyContent="center">
          <TextField
            label="パスワード"
            type={showOldPassword ? "text" : "password"}
            disabled={!isResetPassword}
            size="small"
            margin="normal"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            sx={{
              width: "80%",
              backgroundColor: !isResetPassword ? "#a0a0a0" : "inherit",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowOldPassword((prev) => !prev)}
                  >
                    {showOldPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box display="flex" justifyContent="center">
          <TextField
            label="新しいパスワード"
            type={showNewPassword ? "text" : "password"}
            disabled={!isResetPassword}
            size="small"
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{
              width: "80%",
              backgroundColor: !isResetPassword ? "#a0a0a0" : "inherit",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowNewPassword((prev) => !prev)}
                  >
                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box display="flex" justifyContent="center">
          <Box width="80%" sx={{ ml: 8 }}>
            <Typography
              color={isPasswordValid ? "green" : "error"}
              fontSize="12px"
              mb={0.5}
            >
              ● 8文字以上
            </Typography>
            <LinearProgress
              variant="determinate"
              value={Math.min((newPassword.length / 8) * 100, 100)}
              sx={{
                height: 6,
                width: "50%",
                borderRadius: 4,
                backgroundColor: "#ddd",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: isValidLength ? "#2EE59D" : "#e53935",
                },
              }}
            />
          </Box>
        </Box>

        <Box display="flex" justifyContent="center">
          <TextField
            label="新しいパスワード（確認用）"
            type={showConfirmPassword ? "text" : "password"}
            disabled={!isResetPassword}
            size="small"
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{
              width: "80%",
              backgroundColor: !isResetPassword ? "#a0a0a0" : "inherit",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <Box
        mt={2}
        p={2}
        mx="auto"
        display="flex"
        justifyContent="space-around"
        gap={8}
        // justifyContent="center"
        width="60%"
      >
        <Box sx={{ width: "40%" }}>
          <ImageButton fullWidth onClick={handleConnectAmazon} />
          {/* <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => setAmazonSettingDialogOpen(true)}
          >
            Amazon設定を開く
          </Button> */}
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={!validationCheck()}
          onClick={() => handleUpdateCheck()}
        >
          更新
        </Button>
      </Box>

      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default UserInfo;
